import { render, staticRenderFns } from "./TrialUserBanner.vue?vue&type=template&id=9b6a04fa&scoped=true"
import script from "./TrialUserBanner.vue?vue&type=script&lang=js"
export * from "./TrialUserBanner.vue?vue&type=script&lang=js"
import style0 from "./TrialUserBanner.vue?vue&type=style&index=0&id=9b6a04fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6a04fa",
  null
  
)

export default component.exports